module.exports = __webpack_public_path__ + "img/jindu.fa339c9a.jpg";